<ngx-core-ch-error-page
  errorPageTitle="{{ errorPageTitle | translate }}"
  errorPageText="{{ errorPageText | translate }}"
  message="{{ errorPageMessage | translate }}"
  applicationReloadLabel="{{'core.label.reloadApplication' | translate}}"
>
</ngx-core-ch-error-page>
